import { render, staticRenderFns } from "./Rates.vue?vue&type=template&id=02336662&scoped=true&"
import script from "./Rates.vue?vue&type=script&lang=js&"
export * from "./Rates.vue?vue&type=script&lang=js&"
import style0 from "./Rates.vue?vue&type=style&index=0&id=02336662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02336662",
  null
  
)

export default component.exports